import { Component } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SalaryPaymentService } from '../../../../../core/services/salary-payment.service';
import { SalaryGridService } from '../../../../../core/services/salary-grid.service';
import { PersonalService } from '../../../../../core/services/personal.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  selector: 'app-salary-payment',
  templateUrl: './salary-payment.component.html',
  imports: [CommonModule, FormsModule, NgbModule, NgSelectModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgxPaginationModule],
  styleUrls: ['./salary-payment.component.css']
})
export class SalaryPaymentComponent {
  buttonsPermission: any;
  search_text = '';
  data: any[] = [];
  personals: any[] = [];
  grids: any[] = [];
  selected_data: any;
  loading = false;

  form: any = this.emptyForm();
  calc: any = null;          // aperçu du calcul (brut/cnss/its/net)

  readonly PAYMENT_METHODS = ['Espèces', 'Virement', 'Mobile Money', 'Chèque'];
  pg = { pageSize: 10, p: 0, total: 0 };

  constructor(
    private spService: SalaryPaymentService,
    private gridService: SalaryGridService,
    private personalService: PersonalService,
    private toastrService: ToastrService,
    config: NgbModalConfig,
    private modalService: NgbModal
  ) { config.backdrop = 'static'; config.keyboard = false; }

  ngOnInit(): void {
    this.buttonsPermission = { show: true, add: true, edit: true, delete: true, status: true };
    this.getAll(); this.getPersonals(); this.getGrids();
  }

  emptyForm() {
    return {
      personal_id: null, salary_grid_id: null,
      period: new Date().toISOString().substring(0, 7),
      base_salary: 0, allowances: 0, other_deductions: 0,
      payment_method: 'Virement', notes: ''
    };
  }

  getAll() {
    this.loading = true;
    this.spService.getAll().subscribe((res: any) => {
      this.loading = false; this.data = res.data ?? []; this.pg.total = this.data.length;
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Bulletins de paie', err); });
  }
  getPersonals() { this.personalService.getAll().subscribe((res: any) => { this.personals = res.data ?? []; }, () => {}); }
  getGrids()     { this.gridService.getAll().subscribe((res: any) => { this.grids = res.data ?? []; }, () => {}); }

  /** Pré-remplit base + primes depuis la grille sélectionnée */
  onGridChange() {
    const g = this.grids.find(x => x.id == this.form.salary_grid_id);
    if (g) {
      this.form.base_salary = +g.base_salary;
      this.form.allowances = (+g.transport_allowance || 0) + (+g.housing_allowance || 0) + (+g.other_allowance || 0);
    }
    this.recompute();
  }

  /** Aperçu temps réel du calcul de paie */
  recompute() {
    this.spService.preview({
      base_salary: this.form.base_salary,
      allowances: this.form.allowances,
      other_deductions: this.form.other_deductions
    }).subscribe((res: any) => { this.calc = res.data; }, () => {});
  }

  store(value: any) {
    this.loading = true;
    this.spService.store(value).subscribe((res: any) => {
      this.loading = false; this.toastrService.success(res.message); this.modalService.dismissAll(); this.form = this.emptyForm(); this.calc = null; this.getAll();
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Bulletins de paie', err); });
  }

  update(value: any) {
    this.loading = true;
    this.spService.update(this.selected_data.id, value).subscribe((res: any) => {
      this.loading = false; this.toastrService.success(res.message); this.modalService.dismissAll(); this.getAll();
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Bulletins de paie', err); });
  }

  setStatus(state: number) {
    this.spService.setState(this.selected_data.id, state).subscribe((res: any) => {
      this.toastrService.success(res.message); this.getAll();
    }, (err: any) => AppErrorShow.showError('Bulletins de paie', err));
  }

  delete() {
    if (!this.verifyChecked()) return;
    AppSweetAlert.confirmBox('info', 'Suppression', 'Supprimer ce bulletin de paie ?').then((r: any) => {
      if (r.isConfirmed) this.spService.delete(this.selected_data.id).subscribe((res: any) => {
        this.toastrService.success(res.message); this.getAll();
      }, (err: any) => AppErrorShow.showError('Bulletins de paie', err));
    });
  }

  checked(el?: any) { this.selected_data = el; }
  verifyChecked() { if (!this.selected_data) { this.toastrService.warning('Aucun élément sélectionné'); return false; } return true; }

  add(c: any) { this.form = this.emptyForm(); this.calc = null; this.modalService.open(c, { size: 'lg' }); }
  show(c: any) { if (!this.verifyChecked()) return; this.modalService.open(c, { size: 'lg' }); }

  dismiss() { this.modalService.dismissAll(); }
  getPage(e: any) { this.pg.p = e; }

  statusLabel(s: number) { return s == 1 ? 'Payé' : (s == 2 ? 'Brouillon' : 'Annulé'); }
  statusClass(s: number) { return s == 1 ? 'bg-green-100 text-green-700' : (s == 2 ? 'bg-orange-100 text-orange-700' : 'bg-gray-100 text-gray-500'); }
  personalName(p: any) { return p ? `${p.firstname} ${p.lastname}` : '—'; }
}
